// 导出页面为PDF格式
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
export default {
  install(Vue, options) {
    Vue.prototype.getPdfL = function(title) {
      console.log(title, "title");
      let pdfDom = document.querySelector("#pdfDomL");
      html2Canvas(pdfDom, {
        allowTaint: true
      }).then(function(canvas) {
        let pageData = canvas.toDataURL("image/jpeg", 1);
        let PDF = new JsPDF("l", "pt", "a4");
        PDF.addImage(pageData, "JPEG", 0, 0);
        PDF.save(title + ".pdf");
      });
    };
  }
};



// WEBPACK FOOTER //
// ./src/util/htmlToPdfL.js